// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"647":"d79e48e58d24bd0d","7160":"2760218378fbd7af","8739":"73a029b1562a232e"}[chunkId] + ".js";
};